if (!customElements.get('ct-sticky-cart')) {
  customElements.define(
    'ct-sticky-cart',
    class extends HTMLElement {
      connectedCallback() {
        this.mainButton = document.querySelector('.product-form__submit');
        this.stickyButton = this.querySelector('[data-ct-sticky-submit]');
        if (!this.mainButton || !this.stickyButton) return;

        this.stickyButton.addEventListener('click', () => this.mainButton.click());
        this.observer = new IntersectionObserver(
          ([entry]) => {
            this.hidden = entry.isIntersecting;
          },
          { threshold: 0.1 }
        );
        this.observer.observe(this.mainButton);
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }
    }
  );
}
